import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Skill } from '@app/core/interfaces/c5/acd/skill';
import { Utils } from '@app/shared/services/utils.service';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterSkillRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(callCenterId: number, callCenterSkill: Partial<Skill>): Observable<void> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/skill`)
      .pipe(mergeMap((url) => this.http.post<void>(url, callCenterSkill)));
  }

  delete(callCenterId: number, id: number): Observable<void> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/skill/${id}`)
      .pipe(mergeMap((url) => this.http.delete<void>(url)));
  }

  get(callCenterId: number, id: string): Observable<Skill> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/skill/${id}`)
      .pipe(mergeMap((url) => this.http.get<Skill>(url)));
  }

  list(callCenterId: number): Observable<Skill[]> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/skill`)
      .pipe(mergeMap((url) => this.http.get<Skill[]>(url)));
  }

  update(callCenterId: number, callCenterSkill: Skill): Observable<void> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/skill/${callCenterSkill.id}`)
      .pipe(mergeMap((url) => this.http.put<void>(url, callCenterSkill)));
  }
}
